import styled from "styled-components";
import NanoFlex from "./../../../Global/NanoFlex.js";
import Type from "./../../../Global/Typography.js";
import BaseComponent from "./../../../BaseComponent.js";

import { ReactComponent as RapportsPreDefinis } from "../../icons/rapportsPreDefinis.svg";

const StyledToggleButtonPrompts = styled(NanoFlex)`
  height: auto;
  width: auto;
  .toggleButtonPromptsWrapper {
    padding: 8px;
    user-select: none;
    cursor: pointer;
    background-color: ${(props) => (props.active ? props.theme.color.colorsPalette.yellow : props.theme.color.colorsPalette.lightGrey)};
    .iconBtnWrapper {
      width: auto;
      margin-right: 8px;
      svg {
        width: 18px;
        height: auto;
        path {
          fill: ${(props) => (props.active ? props.theme.color.main.font : props.theme.color.main.font)};
        }
      }
    }
    .textBtnWrapper {
      width: auto;
      p {
        margin-top: 2px;
        /* color: ${(props) => (props.active ? props.theme.color.main.white : props.theme.color.main.font)}; */
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
`;

export default class ToggleButtonPrompts extends BaseComponent {
  render() {
    return (
      <StyledToggleButtonPrompts flexDirection="column" active={this.props.active} onClick={this.props.clickAction}>
        <NanoFlex className="toggleButtonPromptsWrapper">
          <NanoFlex className="iconBtnWrapper">
            <RapportsPreDefinis />
          </NanoFlex>
          <NanoFlex className="textBtnWrapper">
            <Type.p>Prompts</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledToggleButtonPrompts>
    );
  }
}
